import {Container, Row, Col} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Sanjay from '../../../images/avatars/Sanjay.jpg';
import Shuchen from '../../../images/avatars/Shuchen.png';
import Yucheng from '../../../images/avatars/Yucheng.png';
import Jeffrey from '../../../images/avatars/Jeffrey.png';
import Joowon from '../../../images/avatars/Joowon.png';
import Lijian from '../../../images/avatars/Lijian.png';
import Holly from '../../../images/avatars/Holly.png';
import Elena from '../../../images/avatars/Elena.png';
import Kevin from '../../../images/avatars/Kevin.png';
import Yaning from '../../../images/avatars/Yaning.png';
import Vali from '../../../images/avatars/Vali.png';
import You from '../../../images/avatars/You.png';
import Incubator from '../../../images/incubator.png';
import SittingOnChair from '../../../images/sitting-on-chair.png';
import Map from '../../../images/Map.png';
import JoinUsBtn from '../../../images/join-us-button.png';
import * as Styled from './AboutUsStyle';
import Navigation from '../../components/Navigation/Navigation';
import Headline from '../../components/Headline/Headline';
import FooterNav from '../../components/FooterNav/FooterNav';
import Meta from '../../components/Meta/Meta';

const team = [{
  name: 'Elena',
  image: Elena,
}, {
  name: 'Holly',
  image: Holly,
}, {
  name: 'Jeffrey',
  image: Jeffrey,
}, {
  name: 'Joowon',
  image: Joowon,
}, {
  name: 'Kevin',
  image: Kevin,
}, {
  name: 'Lijian',
  image: Lijian,
}, {
  name: 'Sanjay',
  image: Sanjay,
}, {
  name: 'Shuchen',
  image: Shuchen,
}, {
  name: 'Vali',
  image: Vali,
}, {
  name: 'Yucheng',
  image: Yucheng,
}, {
  name: 'Yaning',
  image: Yaning
}]

const AboutUs = () => {

  return (
    <Styled.PageWrapper>
      <Meta page="aboutus" />
      <Navigation logoText />
      <Styled.PageSection>
        <Container fluid="lg">
          <Row>
            <Col>
              <Headline tag="h1" style={{fontWeight: 800}}>
                We're Trova.
              </Headline>
              <Styled.HeadContent>
                Trova is a young startup with a team of exceptional and fun individuals dedicated to things we are enthusiastic about. The teams’ cross-functional skills complement each other to create an impactful solution that increases productivity and makes users’ lives easier.
              </Styled.HeadContent>
            </Col>
          </Row>
        </Container>
      </Styled.PageSection>
      <Styled.PageSection className="bg-blue">
        <Container fluid="lg">
          <Row>
            <Col>
              <Headline tag="h2" style={{ marginBottom: 40}}>
                Team
              </Headline>
            </Col>
          </Row>
          <Row className="justify-content-around justify-content-sm-between">
            {team.map((tm) => (
              <Col key={tm.name} xs={6} sm={4} lg={3} style={{ maxWidth: 230 }}>
                <Styled.AvatarContainer>
                  <Styled.AvatarImg src={tm.image} />
                  <Styled.AvatarName>
                    {tm.name}
                  </Styled.AvatarName>
                </Styled.AvatarContainer>
              </Col>
            ))}
            <Col xs={6} sm={4} lg={3} style={{ maxWidth: 230 }}>
              <Link to="/careers">
                <Styled.AvatarContainer>
                  <Styled.AvatarImg
                    src={You}
                  />
                  <Styled.AvatarName>
                    You
                  </Styled.AvatarName>
                </Styled.AvatarContainer>
              </Link>
            </Col>
          </Row>
        </Container>
      </Styled.PageSection>
      <Styled.PageSection>
        <Container fluid="lg">
          <Row>
            <Col>
              <Headline tag="h2" className="findUs">
                You can find us at...
              </Headline>
            </Col>
          </Row>
        </Container>
        <Container fluid>
          <Row className="align-items-end">
            <Col xs={12} sm={6}>
              <Styled.Img src={Incubator} />
            </Col>
            <Col xs={12} sm={6} lg={{span: 5, offset: 1}}>
              <Headline tag="h4" className="mt-5 mt-sm-0">
                EnterpriseWorks
              </Headline>
              <div style={{ fontSize: 18, lineHeight: '32px', color: '#2c2B48', fontWeight: 400, marginBottom: 20}}>
                60 Hazelwood Dr, Champaign, IL 61820
              </div>
              <Styled.Img src={Map} className="d-none d-sm-block" />
            </Col>
          </Row>
        </Container>
        <Container fluid="lg">
          <Row>
            <Col>
              <Styled.HiringContainer>
                <Styled.SittingImg src={SittingOnChair} />
                <Headline tag="h2" style={{marginBottom: 30}}>
                  We're hiring!
                </Headline>
                <Container fluid>
                  <Row className="align-items-end" >
                    <Col sm={8} md={9} style={{ paddingLeft: 0, fontSize: 20, lineHeight: '32px' }}>
                      We’re looking for talented people to join our team. <br/>
                      Please check our Careers page for openings.
                    </Col>
                    <Col sm={4} md={3} className="text-center text-sm-right mt-5 mt-sm-0">
                      <Styled.JoinBtn href="/careers">
                        <img src={JoinUsBtn} width="100%" alt="join us" />
                      </Styled.JoinBtn>
                    </Col>
                  </Row>
                </Container>
              </Styled.HiringContainer>
            </Col>
          </Row>
        </Container>
      </Styled.PageSection>
      <FooterNav />
    </Styled.PageWrapper>
  )
}

export default AboutUs;